export default "__VITE_ASSET__D9PZc8S$__"